export interface ResponseError {
    errors: ResponseErrorsEntry[];
}

export interface ResponseErrorsEntry {
    code: string;
    field?: string;
}

export class ResponseErrorsData implements ResponseError {
    hasFields: boolean;
    errors: ResponseErrorsEntry[];

    constructor(errors: ResponseErrorsEntry[]) {
        this.hasFields = errors?.some((error) => error.field);
        this.errors = errors ?? [];
    }
}
